import {
	reportCacheBridgeFailureDiagnostic,
	type CacheBridgeFailureContext,
	type CacheBridgeFailureDiagnostic,
} from './cacheBridgeFailureReporter.ts';

function getCacheBridgeFailureMessage(context: CacheBridgeFailureContext): string {
	return `[APOLLO RELAY CACHE SYNC] Secondary ${context.bridge} cache bridge ${context.operation} failed while accessing the ${context.targetCache} cache.`;
}

function getCacheBridgeFailureImpact(context: CacheBridgeFailureContext): string {
	return context.operation === 'read'
		? 'The failed secondary cache read is treated as a cache miss. Original read semantics are preserved.'
		: 'The original operation remains successful. The secondary cache may be stale or incomplete.';
}

function getCacheBridgeFailureAction(context: CacheBridgeFailureContext): string {
	return context.operation === 'read'
		? 'Inspect the error stack and target cache read path to determine why fallback data could not be read.'
		: 'Inspect the error stack and target cache write path to determine why mirroring did not complete.';
}

function buildCacheBridgeFailureDiagnostic(
	error: unknown,
	context: CacheBridgeFailureContext,
): CacheBridgeFailureDiagnostic {
	return {
		...context,
		message: getCacheBridgeFailureMessage(context),
		impact: getCacheBridgeFailureImpact(context),
		action: getCacheBridgeFailureAction(context),
		error,
	};
}

export function reportCacheBridgeFailure(error: unknown, context: CacheBridgeFailureContext): void {
	try {
		reportCacheBridgeFailureDiagnostic(buildCacheBridgeFailureDiagnostic(error, context));
	} catch {
		// Reporting must not turn a secondary cache bridge failure into a primary operation failure.
	}
}
